import { Box, Button } from "@mui/material";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import TextField from "ui/atoms/TextField";
import * as yup from "yup";
import { styled } from "@mui/material";
import MultipleSelectChip from "ui/organisms/MultipleSelectChip";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import groupHelper from "lib/helpers/groupsHelper";

const GroupForm = ({
  group,
  loading,
  actions,
  handleSubmit,
  selectedActions,
  submitButtonText,
  setSelectedActions,
}: any) => {
  const validationSchema = yup.object().shape({
    name: yup.string().required("El nombre es requerido"),
    description: yup.string().required("La descripcion es requerida"),
    actions: yup.array().min(1, "Seleccione al menos un permiso"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: group?.name || "",
      description: group?.description || "",
      actions: groupHelper.getActionsFromGroup(group),
    },
    validationSchema,
    onSubmit: (values) => {
      const dataCoverted = groupHelper.convertFormDataToGroup(values, group?.groupID, selectedActions);
      handleSubmit(dataCoverted);
    },
  });

  return (
    <Box
      component='form'
      sx={{
        width: 600,
        margin: "auto",
        maxWidth: "100%",
      }}
      noValidate
      autoComplete='off'
      onSubmit={formik.handleSubmit}
    >
      <TextField
        id='name'
        name='name'
        margin='normal'
        label='Nombre'
        value={formik.values.name}
        onChange={formik.handleChange}
        error={formik.touched.name && Boolean(formik.errors.name)}
        helperText={formik.touched.name && formik.errors.name}
      />
      <TextField
        id='description'
        name='description'
        margin='normal'
        label='Descripción'
        value={formik.values.description}
        onChange={formik.handleChange}
        error={formik.touched.description && Boolean(formik.errors.description)}
        helperText={formik.touched.description && formik.errors.description}
      />
      <MultipleSelectChip
        formik={formik}
        id='actions'
        name='actions'
        keyToMap='description'
        dataSourse={actions}
        label='Asignar Permisos'
        setItemSelected={setSelectedActions}
        value={formik.values.actions}
        error={formik.touched.actions && Boolean(formik.errors.actions)}
        helperText={formik.touched.actions && formik.errors.actions}
      />
      <ButtonContainer>
        <Link to='/admin/roles'>
          <Button type='button'>Volver</Button>
        </Link>
        <LoadingButton
          size='small'
          type='submit'
          loading={loading}
          loadingPosition='start'
          startIcon={<SaveIcon />}
          disabled={loading}
        >
          <span>{submitButtonText}</span>
        </LoadingButton>
      </ButtonContainer>
    </Box>
  );
};

const ButtonContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(2, 0)};
`;
export default GroupForm;
